import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { fetchItems, ICountry } from '@/api/countries'
import useCrudStore from '@/hooks/useCrudStore'

type CountryEntry = {
  key: string
  label: string
  disabled?: boolean
}

export const useCountriesStore = defineStore('countries', () => {
  const { items, sorted, GetItems } = useCrudStore({
    fetchItems
  })

  // Getters
  const forSelector = computed(() => {
    const countries = sorted.value
    return countries.map<CountryEntry>((country: ICountry) => {
      return {
        key: country.attributes.iso,
        label: country.attributes.name,
        disabled: false
      }
    })
  })

  const byIso = computed(() => {
    return (iso: string[]) => {
      return Object.values(items.value).filter((country: ICountry) =>
        iso.includes(country.attributes.iso)
      )
    }
  })

  const byId = computed(() => {
    return (id: string[]) => {
      return Object.values(items.value).filter((country: ICountry) =>
        id.includes(country.id)
      )
    }
  })

  return {
    items,
    GetItems,

    forSelector,
    sorted,
    byIso,
    byId
  }
})
